<script setup lang="ts">
import type { CmsElementBioCircle } from "~/composables/useCustom";
import SharedHeadline from "~/components/shared/SharedHeadline.vue";
import SharedTopline from "~/components/shared/SharedTopline.vue";

const props = defineProps<{
  content: CmsElementBioCircle;
}>();

const { Boxes, mainText } = props.content.data

</script>
<template>
  <section class="relative ">
    <div class="container px-0 xl:px-5">
      <div class="lg:w-3/4 mx-auto mb-7 text-center">
        <div v-html="mainText"></div>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-5 prose-h3:mb-5">
        <template v-for="(box, index) in Boxes" :key="index">
          <div class="bg-skin-white rounded-10 p-10 pb-20 relative">
            <div class="eql flex items-center mb-7">
              <NuxtImg v-if="box.boxImage && box.boxImage.media" :src="box.boxImage.media.url" alt="" style="max-height:99px;" height="99"/>
            </div>
            <h3 v-html="box.boxHeadline"></h3>
            <div class="mb-4" v-html="box.boxPosition"></div>
            <div class="absolute w-full left-0 bottom-0 px-10 pb-10 ">
              <SharedButton v-if="box.button"  :button="box.button" class="btn-outline btn-sm" has-arrow="true"></SharedButton>
            </div>
          </div>
        </template>
      </div>
    </div>
  </section>
</template>
